<header class="header-user" [class.combustible-form-tablet-header]="isControlCombustibleSection">
  <button class="btn btn-link text-primary mr-2 p-0 btn-menu" type="button" (click)="toggleSidebar()"
    [ngClass]="isControlCombustibleSection ? 'd-lg-none' : 'd-md-none'">
    <i class="bi bi-list" style="font-size: 1.8rem; color: rgba(0, 0, 0, 1);"></i>
  </button>
  <h4 class="title-menu" [ngClass]="isControlCombustibleSection ? 'd-lg-none' : 'd-md-none'">
    {{ mobileModuleLabel }}
  </h4>

  <img style="cursor: pointer;" (click)="toDashboard()" src="../../../assets/images/html/logo-popaico-dashboard.png"
    alt="logo" class="logo logo-polpaico"
    [ngClass]="isControlCombustibleSection ? 'd-none d-lg-block' : 'd-none d-md-block'" />

  <div class="buttons header-buttons">
    <ng-container *ngIf="canShowNotifications">
      <div (click)="isOnline && toggleNotifications()" [style.cursor]="isOnline ? 'pointer' : 'not-allowed'" [style.opacity]="isOnline ? '1' : '0.4'" class="icon-hide notificacion">
        Notificación
      </div>
      <div class="border-left"><br /></div>
    </ng-container>

    <div class="user-name">
      <h6>{{ userName }}</h6>
    </div>

    <div (click)="isOnline && openModalperfil()" [style.cursor]="isOnline ? 'pointer' : 'not-allowed'" [style.opacity]="isOnline ? '1' : '0.4'" class="icon-hide user" [ngClass]="statusCss">
      Perfil
    </div>
  </div>



</header>


<!-- PANEL DE NOTIFICACIONES -->
<div class="notifications-panel" *ngIf="canShowNotifications && showNotifications">
  <!-- Barra superior (desktop y móvil) -->
  <div class="notifications-topbar d-flex align-items-center bg-gray-500">
    <span class="topbar-title">
      Notificaciones
    </span>

    <button type="button" class="btn-close-desktop" (click)="closeNotifications()">
      <i class="bi bi-x-lg" style="font-size: 12px;"></i>
    </button>
  </div>


  <!-- Lista -->
  <div class="notifications-body">
    <div class="notifications-empty" *ngIf="!notificacionesAgrupadas.length">
      <i class="bi bi-bell" aria-hidden="true"></i>
      <p class="notifications-empty-title">No tienes notificaciones</p>
      <p class="notifications-empty-text">Cuando lleguen avisos de tus despachos, aparecerán aquí.</p>
    </div>

    <ng-container *ngFor="let group of notificacionesAgrupadas">
      <div *ngFor="let item of group.items" class="notification-item d-flex justify-content-between align-items-start">
        <div class="d-flex secction-card">
          <div class="me-3 mt-1 secction-icon">
            <!-- aquí luego puedes cambiar ícono según item.titulo -->

            <ng-container [ngSwitch]="item.titulo">
              <img *ngSwitchCase="'Guía Firmada'" src="assets/images/icons/guia_firma.svg" class="img-fluid"
                alt="Guía firmada" />

              <img *ngSwitchCase="'Guía Digital Disponible'" src="assets/images/icons/guia_digital_disponible.svg"
                class="img-fluid" alt="Guía digital disponible" />

              <!-- 👇 Default: cuando no cumple ningún caso anterior -->
              <img *ngSwitchDefault src="assets/images/icons/despacho_actualizado.svg" class="img-fluid"
                alt="Despacho actualizado" />
            </ng-container>


          </div>

          <div class="secction-body">
            <div class="fw-semibold notif-title">
              {{ item.titulo }}
            </div>
            <div class="text-muted notif-text">
              Tu despacho de tu pedido con N° {{ item.folio_h }} cambió de estado.
              <!-- aquí puedes personalizar según el tipo de notificación -->
            </div>
          </div>
        </div>

        <div class="text-muted notif-date secction-date">
          {{ (item.fecha_orden || item.fecha) | date:'MMM d' }}
        </div>
      </div>

      <!-- <hr class="m-0" /> -->
    </ng-container>
  </div>
</div>


<div class="offline-banner" *ngIf="!isOnline">
  <i class="bi bi-wifi-off"></i>
  Sin conexión — los cambios se guardarán automáticamente
</div>

<div class="offline-nav-toast" *ngIf="showOfflineToast">
  No disponible sin conexión
</div>

<div class="overlay" [class.visible]="isSidebarOpen" (click)="toggleSidebar()"></div>

<div class="main-layout" [class.offline-active]="!isOnline"
  [class.combustible-form-tablet-as-mobile]="isControlCombustibleSection">
  <!-- Sidebar fijo -->

  <div class="sidebar-wrap" [class.open]="isSidebarOpen">
    <nav [class.collapsed]="isCollapsed" class="sidebar d-flex flex-column align-items-start p-3">
      <img style="cursor: pointer;" (click)="toDashboard()" src="../../../assets/images/html/logo-popaico-dashboard.png"
        alt="logo" class="logo logo-menu"
        [ngClass]="isControlCombustibleSection ? 'd-lg-none' : 'd-md-none'" />

      <ul class="nav flex-column w-100 mt-3 sidebar-nav">

        <li class="nav-item mb-2" *ngIf="canShowNavigation('dashboard')">
          <a [routerLink]="['/dashboard']" class="nav-link d-flex align-items-center"
            [class.active]="active === 'dashboard'">
            <i class="bi bi-columns-gap mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Dashboard</span>
          </a>
        </li>

        <div class="linea-horizontal" *ngIf="canShowNavigation('dashboard')"></div>

        <li class="nav-item mb-2" *ngIf="canShowNavigation('checklist')">
          <a [routerLink]="isOnline ? ['/checklist'] : null"
            (click)="!isOnline && onLockedNavClick()"
            class="nav-link d-flex align-items-center"
            [class.active]="active === 'checklist'"
            [class.nav-offline-disabled]="!isOnline">
            <i class="bi bi-card-checklist mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Check list</span>
          </a>
        </li>

        <div class="linea-horizontal" *ngIf="canShowNavigation('checklist')"></div>
        <div *ngIf="canShowNavigation('dispatch')">
          <li class="nav-item mb-2">
            <a [routerLink]="['/pedidospendiente']" class="nav-link d-flex align-items-center"
              [class.active]="active === 'despacho'">
              <i class="bi bi-truck mr-3 icon-lg"></i>
              <span *ngIf="!isCollapsed">Despacho actual</span>
              <span class="queue-badge" *ngIf="queueCount > 0 && !isCollapsed">{{ queueCount }}</span>
            </a>
          </li>
        </div>

        <div *ngIf="canShowNavigation('dispatch')" class="linea-horizontal"></div>

        <li class="nav-item mb-2" *ngIf="canShowNavigation('otherDispatches')">
          <a [routerLink]="['/otrosdespachos']" class="nav-link d-flex align-items-center"
            [class.active]="active === 'otrosdespachos'">
            <i class="bi bi-truck-front mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Otros despachos</span>
          </a>
        </li>

        <div *ngIf="canShowNavigation('otherDispatches')" class="linea-horizontal"></div>

        <li *ngIf="canShowNavigation('history')" class="nav-item mb-2">
          <a [routerLink]="isOnline ? ['/pedidosEntregados'] : null"
            (click)="!isOnline && onLockedNavClick()"
            class="nav-link d-flex align-items-center"
            [class.active]="active === 'historial'"
            [class.nav-offline-disabled]="!isOnline">
            <i class="bi bi-clock-history mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Historial</span>
          </a>
        </li>

        <div *ngIf="canShowNavigation('history')" class="linea-horizontal"></div>

       <li *ngIf="canShowNavigation('fatigue')" class="nav-item mb-2">
          <a [routerLink]="isOnline ? ['/fatiga'] : null"
            (click)="!isOnline && onLockedNavClick()"
            class="nav-link d-flex align-items-center"
            [class.active]="active === 'fatiga'"
            [class.nav-offline-disabled]="!isOnline">
           <i class="bi bi-file-text mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Fatiga</span>
          </a>
        </li>

        <div *ngIf="canShowNavigation('fatigue')" class="linea-horizontal"></div>

        <li class="nav-item mb-2" *ngIf="canShowNavigation('fuel')">
          <a [routerLink]="isOnline ? [navigationPath('fuel')] : null"
            (click)="!isOnline && onLockedNavClick()"
            class="nav-link d-flex align-items-center"
            [class.active]="active === 'combustible'"
            [class.nav-offline-disabled]="!isOnline">
            <i class="bi bi-fuel-pump mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Control de combustible </span>
          </a>
        </li>
        <li class="nav-item mb-2" *ngIf="canShowNavigation('daily-close')">
          <a [routerLink]="isOnline ? [navigationPath('daily-close')] : null"
             (click)="!isOnline && onLockedNavClick()"
             class="nav-link d-flex align-items-center"
             [class.active]="active === 'cierre-diario'"
             [class.nav-offline-disabled]="!isOnline">
            <i class="bi bi-clipboard2-check mr-3 icon-lg"></i>
            <span *ngIf="!isCollapsed">Cierre diario</span>
          </a>
        </li>
        <div *ngIf="canShowNavigation('fuel') || canShowNavigation('dispatch')" class="linea-horizontal"></div>

      </ul>

      <div class="sidebar-footer w-100" (click)="isOnline && openModalCerrarSession()" [style.cursor]="isOnline ? 'pointer' : 'not-allowed'" [style.opacity]="isOnline ? '1' : '0.4'">
        <hr />
        <a class="nav-link d-flex align-items-center text-danger">
          <i class="bi bi-box-arrow-right mr-2 icon-lg"></i>
          <span *ngIf="!isCollapsed">Cerrar sesión</span>
        </a>
        <small *ngIf="!isCollapsed" class="text-muted ml-2">v.2.8.11</small>
      </div>
    </nav>

    <!-- Botón de colapsar (solo desktop) -->
    <button class="toggle-btn" (click)="toggleSidebar()"
      [ngClass]="isControlCombustibleSection ? 'd-none d-lg-flex' : 'd-none d-md-flex'">
      <i class="bi" [ngClass]="isCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
    </button>
  </div>


  <!-- Contenido -->
  <div class="main-content" [class.collapsed]="isCollapsed">
    <h4 class="title pl-4 title-menu desktop d-none"
      *ngIf="currentComponent !== 'dashboard' && !isFirmaDigitalDetalle"
      [ngClass]="isControlCombustibleSection ? 'd-lg-block' : 'd-md-block'">
      <div [routerLink]="['/pedidospendiente']" class="goBack" *ngIf="currentComponent === 'PedidosPendientes'">
        <i class="bi bi-arrow-left back-arrow-icon"></i><a> Atrás</a>
      </div>
      <button type="button" class="goBack goBack--bare goBack--combustible-title" *ngIf="isControlCombustibleFormulario"
        (click)="onCombustibleFormularioBack()">
        <i class="bi bi-arrow-left back-arrow-icon" aria-hidden="true"></i><span class="goBack--combustible-title-text">Atrás</span>
      </button>
      {{ menuService.tilteMenu }}
    </h4>

    <div [routerLink]="['/pedidospendiente']" class="goBack goBackResponsive"
      *ngIf="currentComponent === 'PedidosPendientes'"><i class="bi bi-arrow-left back-arrow-icon"></i><a> Atrás</a></div>

    <router-outlet></router-outlet>
  </div>
</div>

<!-- Modales -->
<app-modal-call-to-action [classModal]="clasModalCall"
  (enventoCerrarModalPadre)="cerrarModalCall()"></app-modal-call-to-action>

<app-modal-perfil [classModal]="clasModalPerfil" (enventoCerrarModalPadre)="cerrarModalperfil()"></app-modal-perfil>
<app-modal-confirmar-cerrar-session #modalCerrarSesion [classModal]="classModalCerrarSession" [title]='"Cerrar Sesión"'
  [message]='" ¿Estás seguro que deseas cerrar sesión? "' (enventoCerrarModalPadre)="cerrarModalSession()"
  (enventoCerrarSessionPadre)="cerrarSession()"></app-modal-confirmar-cerrar-session>

<app-modal-info #modalInfo [title]="modalTitle" [message]="modalMessage" [buttonText]="buttonText"></app-modal-info>

<app-chat Origen_Apartado="RUTAS"
  Pregunta="De acuerdo al último despacho, con que nota calificaría nuestro servicio de entrega">
</app-chat>
